import React from 'react';

const MobileMenu = () => {
  return(
    <div className="bar">
      <span className="bar__line"></span>
    </div>
  );
}

export default MobileMenu;